export var QueryOperator;
(function (QueryOperator) {
    QueryOperator["AND"] = "AND";
    QueryOperator["OR"] = "OR";
})(QueryOperator || (QueryOperator = {}));
//# sourceMappingURL=query-operator.enum.js.map